import { toast } from "react-toastify";

export default function copyToClipboard(text, type = "Data") {
  const value = text?.trim?.();

  return (event) => {
    event.stopPropagation();
    if (!value) {
      toast.warning(`No ${type} to copy`);
      return;
    }

    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success(`${type} copied to clipboard`);
      })
      .catch((error) => {
        console.error(error);
        toast.error(`${type} didn't copy`);
      });
  };
}
